import { StorageKeys } from './constants';

export class Storage {
	set refreshToken(value: string | undefined) {
		if (value) {
			localStorage.setItem(StorageKeys.refreshToken, value);
		} else {
			localStorage.removeItem(StorageKeys.refreshToken);
		}
	}

	get refreshToken(): string | undefined {
		return localStorage.getItem(StorageKeys.refreshToken) ?? undefined;
	}

	set idToken(value: string | undefined) {
		if (value) {
			localStorage.setItem(StorageKeys.idToken, value);
		} else {
			localStorage.removeItem(StorageKeys.idToken);
		}
	}

	get idToken(): string | undefined {
		return localStorage.getItem(StorageKeys.idToken) ?? undefined;
	}

	set accessToken(value: string | undefined) {
		if (value) {
			sessionStorage.setItem(StorageKeys.accessToken, value);
		} else {
			sessionStorage.removeItem(StorageKeys.accessToken);
		}
	}

	get accessToken(): string | undefined {
		return sessionStorage.getItem(StorageKeys.accessToken) ?? undefined;
	}

	set authState(value: string | undefined) {
		if (value) {
			sessionStorage.setItem(StorageKeys.authState, value);
		} else {
			sessionStorage.removeItem(StorageKeys.authState);
		}
	}

	get authState(): string | undefined {
		return sessionStorage.getItem(StorageKeys.authState) ?? undefined;
	}

	get redirectCount(): number {
		return Number(localStorage.getItem(StorageKeys.redirectCount) ?? 0);
	}

	incrRedirected = (): void => {
		const count = this.redirectCount;
		localStorage.setItem(StorageKeys.redirectCount, (count + 1).toString());
	}

	resetRedirected = (): void => {
		localStorage.removeItem(StorageKeys.redirectCount);
	}

	reset = (): void => {
		this.accessToken = undefined;
		this.idToken = undefined;
		this.refreshToken = undefined;
		this.authState = undefined;
	}
}